<template>
  <div>
    <el-dialog
      v-if="!isExpert"
      class="dialog-container"
      :visible.sync="dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="cancel"
      title="初审评分表"
      width="90%"
      center
    >
      <div class="flex flex-direction">
        <!--            <div class="table-container">-->
        <el-table
          v-loading="loading"
          :data="lists"
          :span-method="objectSpanMethod"
          border
          header-row-class-name="table-header"
          style="width: 100%"
        >
          <el-table-column label="序号" prop="index" width="80">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.index }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="一级指标" prop="one_name" width="120">
            <template slot-scope="scope">
              <div class="table-item">
                <div>{{ scope.row.one_name }}</div>
                <div>（{{ scope.row.one_score }}分）</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="二级指标" prop="two_name" width="150">
            <template slot-scope="scope">
              <div class="table-item">
                <div>{{ scope.row.two_name }}</div>
                <div>（{{ scope.row.two_score }}分）</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="评分标准" prop="three_name">
            <template slot-scope="scope">
              <div class="table-name">
                {{ scope.row.three_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="分值" prop="four_name" width="120">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.three_score }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="得分" prop="four_score" width="180">
            <template slot-scope="scope">
              <div class="table-item">
                <el-input
                  v-model="scope.row.score"
                  placeholder="请输入"
                  size="mini"
                  :step-strictly="true"
                  :precision="0"
                  :controls="false"
                  :max="scope.row.max_score"
                  :min="scope.row.min_score"
                  :step="scope.row.step"
                  @input="
                    (e) => {
                      return changeScore(scope.row, scope.$index, e);
                    }
                  "
                ></el-input>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-descriptions class="margin-tb-xs" :column="2" border>
          <el-descriptions-item :labelStyle="labelWidthStyle" span="2">
            <template slot="label"> 总分</template>
            <div>{{ total }}</div>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="2" border>
          <el-descriptions-item :labelStyle="labelStyle" span="2">
            <template slot="label"> 点评</template>
            <div>
              <el-input
                v-model="ruleForm.reason"
                type="textarea"
                placeholder="（例如：优化意见、补充要求等）"
                :rows="4"
                :autosize="{ minRows: 4, maxRows: 4 }"
                style="width: 100%"
              ></el-input>
            </div>
          </el-descriptions-item>
        </el-descriptions>
        <!--            </div>-->
        <div
          class="dialog-operate flex align-center justify-center margin-top-sm"
        >
          <el-button class="btn min round" type="info" @click="cancel"
            >取消
          </el-button>
          <el-button
            class="btn min round"
            type="primary"
            @click="save(2, 1)"
            v-if="!rid && is_save"
          >
            保存
          </el-button>
          <el-button
            class="btn min round"
            type="primary"
            @click="save(2, 0)"
            v-if="!rid"
          >
            提交
          </el-button>
        </div>
      </div>
    </el-dialog>

    <Modal
      v-else
      v-model="dialog"
      draggable
      scrollable
      @on-cancel="cancel"
      :mask="false"
      title="初审评分表"
      width="800px"
      footer-hide
      sticky
      :sticky-distance="0"
      :transfer="false"
      lock-scroll
      :styles="{
        top: '0px',
      }"
    >
      <div class="flex flex-direction">
        <!--            <div class="table-container">-->
        <el-table
          v-loading="loading"
          :data="lists"
          :span-method="objectSpanMethod"
          border
          header-row-class-name="table-header"
          style="width: 100%"
        >
          <el-table-column label="序号" prop="index" width="80">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.index }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="一级指标" prop="one_name" width="120">
            <template slot-scope="scope">
              <div class="table-item">
                <div>{{ scope.row.one_name }}</div>
                <div>（{{ scope.row.one_score }}分）</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="二级指标" prop="two_name" width="150">
            <template slot-scope="scope">
              <div class="table-item">
                <div>{{ scope.row.two_name }}</div>
                <div>（{{ scope.row.two_score }}分）</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="评分标准" prop="three_name">
            <template slot-scope="scope">
              <div class="table-name">
                {{ scope.row.three_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="分值" prop="four_name" width="120">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.three_score }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="得分" prop="four_score" width="180">
            <template slot-scope="scope">
              <div class="table-item">
                <el-input
                  v-model="scope.row.score"
                  placeholder="请输入"
                  size="mini"
                  :step-strictly="true"
                  :precision="0"
                  :controls="false"
                  :max="scope.row.max_score"
                  :min="scope.row.min_score"
                  :step="scope.row.step"
                  @input="
                    (e) => {
                      return changeScore(scope.row, scope.$index, e);
                    }
                  "
                ></el-input>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-descriptions class="margin-tb-xs" :column="2" border>
          <el-descriptions-item :labelStyle="labelWidthStyle" span="2">
            <template slot="label"> 总分</template>
            <div>{{ total }}</div>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="2" border>
          <el-descriptions-item :labelStyle="labelStyle" span="2">
            <template slot="label"> 点评</template>
            <div>
              <el-input
                v-model="ruleForm.reason"
                type="textarea"
                placeholder="（例如：优化意见、补充要求等）"
                :rows="4"
                :autosize="{ minRows: 4, maxRows: 4 }"
                style="width: 100%"
              ></el-input>
            </div>
          </el-descriptions-item>
        </el-descriptions>
        <!--            </div>-->
        <div
          class="dialog-operate flex align-center justify-center margin-top-sm"
        >
          <el-button class="btn min round" type="info" @click="cancel"
            >取消
          </el-button>
          <el-button
            class="btn min round"
            type="primary"
            @click="save(2, 1)"
            v-if="!rid && is_save"
          >
            保存
          </el-button>
          <el-button
            class="btn min round"
            type="primary"
            @click="save(2, 0)"
            v-if="!rid"
          >
            提交
          </el-button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  getProjectScoreInfo,
  getProjectScoreRecordInfo,
  projectScoreInfo,
} from "@/api/admin";

import { getProjectScoreRecord } from "@/api";

export default {
  name: "ApplyLevel1Dialog",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
    rid: {
      type: [String, Number],
      default: "",
    },
    isExpert: {
      type: Boolean,
      default: false,
    },
    isUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      labelWidthStyle: {
        width: "calc(100% - 180px)",
        background: "#f0f4f8",
        "text-align": "center",
      },
      labelStyle: {
        width: "150px",
        background: "#f0f4f8",
        "text-align": "justify",
      },
      contentStyle: { "text-align": "justify" },
      loading: false,
      lists: [],

      column_1: [],
      pos_1: 0,
      column_2: [],
      pos_2: 0,

      ruleForm: {
        reason: "",
      },

      approve_status: 1,
      is_save: 1,
    };
  },
  created() {},
  computed: {
    total() {
      return this.lists.reduce((total, item) => {
        return total + (item.score || 0);
      }, 0);
    },
  },
  methods: {
    changeScore(item, index, value) {
      if (value === "") return;
      let newVal = Number(value);
      console.log(newVal, value);
      if (newVal !== undefined) {
        let _error = "";

        if (isNaN(newVal)) {
          _error = `请输入小于${item.max_score}的整数`;
        }
        if (!Number.isInteger(newVal)) {
          _error = `请输入小于${item.max_score}的整数`;
        }
        if (newVal % item.step !== 0) {
          _error = `请输入小于${item.max_score}的整数`;
        }
        // const stepPrecision = this.getPrecision(item.step);
        // const precisionFactor = Math.pow(10, stepPrecision);
        // newVal = Math.round(newVal / item.step) * precisionFactor * item.step / precisionFactor;
        // newVal = parseFloat(Math.round(newVal * Math.pow(10, 0)) / Math.pow(10, 0));

        if (newVal > item.max_score) {
          // newVal = item.max_score;
          _error = `请输入小于${item.max_score}的整数`;
        }
        if (newVal < item.min_score) {
          // newVal = item.min_score;
          _error = `请输入大于${item.min_score}的整数`;
        }
        if (_error) {
          this.$message.error(_error);
          this.lists[index].score = undefined;
        } else {
          this.lists[index].score = newVal;
        }
      }
    },

    async init() {
      this.lists = [];

      let _data = this.isUser
        ? await getProjectScoreRecord(this.id, 1, this.rid)
        : this.rid
        ? await getProjectScoreRecordInfo(this.id, 1, this.rid)
        : await getProjectScoreInfo(this.id, 1);

      _data.data.scoreList.map((item, index) => {
        item.children.map((two, two_index) => {
          two.children.map((three, three_index) => {
            this.lists.push({
              is_show: three_index === 0,
              index: index + (two_index + 1) + index,
              one_id: item.id,
              one_name: item.name,
              one_score: item.score,
              two_id: two.id,
              two_name: two.name,
              two_score: two.score,
              three_id: three.id,
              three_name: three.name,
              three_score: three.score_range,
              min_score: 0,
              max_score: two.score,
              step:
                index === _data.data.scoreList.length - 1 &&
                item.children.length - 1 === two_index
                  ? 5
                  : 1,
              score:
                three_index === 0 ? two.user_score || undefined : undefined,
            });
          });
        });
      });

      if (_data.code === 200) {
        this.ruleForm.reason = _data.data.scoreInfo.reason;
        this.ruleForm.is_save = _data.data.scoreInfo.is_save;
        this.approve_status = _data.data.scoreInfo.approve_status;
      }

      this.getSpanArr(this.lists);
    },
    getSpanArr(data) {
      this.column_1 = [];
      this.column_2 = [];
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.column_1.push(1);
          this.column_2.push(1);
          this.pos_1 = 0;
          this.pos_2 = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].one_id === data[i - 1].one_id) {
            this.column_1[this.pos_1] += 1;
            this.column_1.push(0);
          } else {
            this.column_1.push(1);
            this.pos_1 = i;
          }
          if (
            data[i].two_id === data[i - 1].two_id &&
            data[i].one_id === data[i - 1].one_id
          ) {
            this.column_2[this.pos_2] += 1;
            this.column_2.push(0);
          } else {
            this.column_2.push(1);
            this.pos_2 = i;
          }
        }
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if ([0, 2, 5].includes(columnIndex)) {
        const _row = this.column_2[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col,
        };
      } else if (columnIndex === 1) {
        const _row = this.column_1[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    async save(state, is_save) {
      let _data = await projectScoreInfo(
        1,
        this.id,
        JSON.stringify(
          this.lists
            .filter((item) => item.is_show)
            .map((item) => {
              return {
                id: item.two_id,
                score: item.score || "",
              };
            })
        ),
        this.ruleForm.reason,
        state,
        is_save
      );
      if (_data.code == 200) {
        this.$message.success(_data.message);
        this.$emit("watchState", true);
      } else {
        this.$message.error(_data.message);
      }
    },
    cancel() {
      console.log("取消");

      this.$emit("watchState", false);
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.init();
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ivu-modal-wrap {
  // top: auto !important;
}

::v-deep .ivu-modal-content {
  top: 0 !important;
}

.table-item {
  text-align: center;
}

::v-deep {
  .el-table th.el-table__cell > .cell {
    text-align: center;
    color: #333333;
  }
}
</style>
